module.exports = __webpack_public_path__ + "img/timeline_miscevent-8.e82017cb.jpg";